export enum WindowHapiEventCommandName {
    /* State */
    stateHydrate = "state:hydrate",

    /* Service */
    serviceLoad = "service:load",
    serviceInit = "service:init",
    serviceRequest = "service:request",
    serviceStart = "service:start",
    serviceSuccess = "service:success",
    serviceFailure = "service:failure",
    serviceFinish = "service:finish",

    /* Config */
    configSetPartnerToken = "config:partnerToken", // used for impersonation purposes
    configSetAreLogsEnabled = "config:areLogsEnabled",
    configSetWalletCurrency = "config:setWalletCurrency",

    /* App */
    appLoad = "app:load",
    appReady = "app:ready",
    appHydrated = "app:hydrated",

    /* API */
    apiRequest = "api:request",

    /* QA */
    qaRequest = "qa:request",

    /* DOM */
    iframeLoaded = "dom:iframe-loaded",
    iframeUnloaded = "dom:iframe-unloaded",
    domAppendChild = "dom:append-child",
    domElementEvent = "dom:element-event",
    domRemoveChild = "dom:remove-child",
    domHideElement = "dom:hide-element",
    domShowElement = "dom:show-element",
    domSetStyleAttribute = "dom:set-style-attribute",
    domSetAttribute = "dom:set-attribute",
    domAddClass = "dom:add-class",
    domRemoveClass = "dom:remove-class",
    domSlotAvailable = "dom:slot-available",
    domElementMounted = "dom:element-mounted",
    domElementUnmounted = "dom:element-unmounted",

    /* Location */
    locationSetHref = "location:href",
}

export enum EventCommandErrorResponse {
    stateNotFound = "state-undefined-or-not-found",
}
